T.Footer = Class(
	/**
	 * @lends {T.Footer#}
	 */
	{
		__construct() {
			this.node = mkE({
				tag: 'footer',
				id: 'footer',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							this._top = mkE({
								tag: 'div',
								className: 'top'
							}),
							this._middle = mkE({
								tag: 'div',
								className: 'middle'
							}),
							this._bottom = mkE({
								tag: 'div',
								className: 'bottom'
							})
						]
					}
				]
			});
			this._drawTop();
			this._drawMiddle();
			this._drawBottom();
		},

		_drawTop() {
			let links = [];
			D.FOOTER.links.forEach(link => {
				let linkNode = mkE({
					tag: 'li',
					els: [
						{
							tag: 'a',
							href: link.href,
							text: link.text
						}
					]
				});
				links.push(linkNode);
			});
			mkE({
				tag: 'nav',
				id: 'footer-nav',
				els: [
					{
						tag: 'ul',
						els: links
					}
				]
			}).append(this._top);
			mkE({
				tag: 'div',
				className: 'info',
				els: [
					{
						tag: 'div',
						className: 'caption',
						text: D.FOOTER.info.title
					},
					{
						tag: 'p',
						text: D.FOOTER.info.text
					}
				]
			}).append(this._top);
			mkE({
				tag: 'a',
				className: 'email color-turquoise',
				href: D.FOOTER.contacts.href,
				text: D.FOOTER.contacts.text
			}).append(this._top);
		},

		_drawMiddle() {
			new T.Download().append(this._middle);
		},

		_drawBottom() {
			mkE({
				tag: 'div',
				className: 'liaa',
				text: D.FOOTER.liaa
			}).append(this._bottom);
			mkE({
				tag: 'div',
				className: 'logo'
			}).append(this._bottom);
			mkE({
				tag: 'div',
				className: 'copyright',
				text: D.FOOTER.copyright.text
			}).append(this._bottom);
			mkE({
				tag: 'div',
				className: 'eraf-logo'
			}).append(this._bottom);
			mkE({
				tag: 'div',
				className: 'dg-logo'
			}).append(this._bottom);
		}
	},
	mkE.Base
);
T.Footer._footer = null;
T.Footer.get = function() {
	if (T.Footer._footer) {
		return T.Footer._footer;
	}
	T.Footer._footer = new T.Footer();
	return T.Footer._footer;
};